import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreTaskService } from '../core-task.service';
import { CoreTaskDataService } from 'app/examination/core-task-data.service';
import { Subscription } from 'rxjs/Subscription';
import { CoreTask } from '../core-task';
import { StateService } from 'app/state.service';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-examination',
  templateUrl: './examination.component.html',
  styleUrls: ['./examination.component.scss']
})
export class ExaminationComponent implements OnInit, OnDestroy, AfterViewInit {

  public coreTask: CoreTask;
  private coreTaskDataSubscription: Subscription;
  private routeSubscription: Subscription;

  public dataCheckSuccessful = false;
  constructor(private route: ActivatedRoute, private coreTaskService: CoreTaskService,
    private coreTaskDataService: CoreTaskDataService, private router: Router, private breadcrumbService: BreadcrumbService,
    private stateService: StateService) { }

  ngOnInit() {
    this.routeSubscription = this.route.params.subscribe(data => {
      const id = data['examinationId'];
      this.coreTaskService.getCoreTaskByStudentCreboId(id).subscribe((coreTask: CoreTask) => {
        this.coreTask = coreTask;
        // this.stateService.resetState();
        this.stateService.workProcesses = coreTask.werkproces;
      })
    });
  }

  ngAfterViewInit() {
      setTimeout(() => {
        this.breadcrumbService.updateBreadcrumb();
      });
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
    // this.coreTaskDataSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/examination/examination/examination.component.ts